module.exports = __webpack_public_path__ + "static/media/destination.1dff4f13.jpg";